class _NIL {}
export const NIL = new _NIL();

export function isNIL(v) {
  return v === NIL;
}
